import { QueryClient } from '@tanstack/react-query';

// Reuse route preloads for 30 seconds, including the handoff to the mounted view.
export const routePreloadStaleTime = 30_000;

export function createWorkspaceQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 0, retry: false, refetchOnWindowFocus: true },
    },
  });
}
